<template>
  <div>
    <OnboardingTopBar />
    <!-- step 1 -->
    <div class="parent-box">
      <div class="heading">
        <img width="200" :src="require('../../../../assets/img/goal.svg')" />
        <h2 class="login-title">Congratulations!</h2>
        <p class="text">
          You are on your way to enjoying stable power supply! We are now
          processing your unit for installation and will call you soon to
          finalize the documentation and installation process.
        </p>
        <p class="text">
          An email with your purchase details has been sent to you. Thank you
          for choosing Arnergy.
        </p>
      </div>
      <div class="footer">
        <!-- real footer item -->
        <!-- <button class="submit-button" @click="goToDash">Visit Dashboard</button> -->
      </div>
      <success-animation></success-animation>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";
import SuccessAnimation from "../../../SuccessAnimation.vue";
import OnboardingTopBar from "@/components/OnboardingTopBar.vue";
import OnboardingService from "@/services/onboarding.js";
// import OnboardingTopBar from "../ArnergyInventoryComponents/";

export default {
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {
    SuccessAnimation,
    OnboardingTopBar
  },
  computed: {},
  data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    async updateStateFunc() {
      await OnboardingService.updateDbData({
        iscompleted: true
      });
      // console.log("presssed");
      // const HTTP = this.$httpUtils.instance;
      // HTTP.patch("/onboardingStates", {
      //   customerid: localStorage.customerId,
      //   stateid: 6,
      //   iscompleted: true,
      //   id: localStorage.customerState
      // }).then(res => {});
    },
    goToDash() {
      console.log("test");
      const HTTP = this.$httpUtils.instance;
      HTTP.post("/onboardingNotifications/sendAccountRegistrationEmail", {
        firstName: localStorage.firstName,
        lastName: localStorage.lastName,
        email: localStorage.email,
        iscompleted: true
      })
        .then(res => {
          this.updateStateFunc();
          if (res.data) {
            console.log(res.data);
            window.location.href = "/";
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  async mounted() {
    this.updateStateFunc();
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";
.parent-box {
  position: relative;
  margin-top: 50px;
}

.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  // color: $primary-color;
}

.text {
  color: #666666;
}

.space {
  margin: 20px 0;
  margin-left: 20px;
  color: #8f8d8c;

  span {
    color: black;
    font-weight: bold;
  }
}

.misbehave {
  margin: 50px auto 20px auto;
  max-width: 550px;
}

.packages {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  div {
    margin: 10px;
  }
}

.footer {
  margin: 50px auto;
  max-width: 550px;

  td {
    color: black;
    text-align: left;
    padding: 20px !important;

    &:first-child {
      text-align: right;
      color: #666666;
    }
  }
}

button:disabled {
  opacity: 0.3;
}

.flex {
  display: flex;
  align-items: center;

  > :first-child {
    margin-right: 5px;
  }
}

.intro-title {
  text-align: center;
  position: relative;

  .text {
    font-weight: bold;
    position: relative;
    z-index: 10;
    display: inline;
    background: white;
    padding: 0 20px;
  }

  &:before {
    width: 100%;
    height: 2px;
    background: #ebebeb;
    display: block;
    content: "";
    position: absolute;
    top: 10px;
    z-index: 0;
    // bottom: 0;
  }
}

.paying-now {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ebebeb;
  padding: 10px 0;
  font-size: 24px;

  span {
    color: black;
    font-weight: bold;
  }

  span:first-child {
    font-size: 12px;
    margin-right: 10px;
  }
}

.footer-lock {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;

  .small {
    font-weight: bold;
    margin-left: 5px;
    color: black;
  }
}

.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/FinishTab.vue